export const OneDependencyNotInstalledNotificationDataHooks = {
  container: 'one-dependency-not-installed-notification-container',
  description: 'one-dependency-not-installed-notification-description',
};
